import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogoutComponent } from './root/logout/logout.component';
import { SiteRedirectComponent } from './root/callbacks/site-redirect/site-redirect.component';
import { BrokerResolver } from './root/resolvers/broker-resolver';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { TraxGuard } from './root/guards/trax-guard';

const routes: Routes = [
  { 
    path: '', 
    redirectTo: 'loadDetails', 
    pathMatch: 'full' 
  },
  {
    path: 'silentcallback',
    component: MsalRedirectComponent
  },
  {
    path: 'authcallback',
    component: MsalRedirectComponent
  },
  { path: 'logout', component: LogoutComponent },
  { path: 'traxlogout', component: LogoutComponent },
  { path: 'trax', canActivate: [TraxGuard],
    children: [
      { path: '', component: SiteRedirectComponent },
      { path: 'loadDetails', component: SiteRedirectComponent },
      { path: 'rateSelection/:quoteId', component: SiteRedirectComponent },
      { path: 'routeDetails', component: SiteRedirectComponent },
      { path: 'review', component: SiteRedirectComponent },
      { path: 'loadDetailsTender', component: SiteRedirectComponent },
      { path: 'routeDetailsTender', component: SiteRedirectComponent },
      { path: 'reviewTender', component: SiteRedirectComponent },
    ]
  },
  // END
  { 
    path: 'loadDetails', 
    loadChildren: () => import('./load-details/load-details.module').then(m => m.LoadDetailsModule),
    canLoad: [MsalGuard],
    resolve: {broker: BrokerResolver},
    data: {
      title: 'FTL QUOTE',
      navTitle: 'Load Details',
      navOrder: 1
    }
  }, 
  { 
    path: 'loadDetailsTender', 
    loadChildren: () => import('./load-details/load-details.module').then(m => m.LoadDetailsModule),
    canLoad: [MsalGuard],
    resolve: {broker: BrokerResolver},
    data: {
      title: 'TENDER FTL',
      navTitle: 'Load Details',
      navOrder: 1
    }
  }, 
  { 
    path: 'rateSelection', 
    loadChildren: () => import('./rate-selection/rate-selection.module').then(m => m.RateSelectionModule),
    canLoad: [MsalGuard],
    resolve: {broker: BrokerResolver},
    data: {
      title: 'FTL QUOTE',
      navTitle: 'Rate Selection',
      navOrder: 2,
      hideFromBar: true
    }
  },
  { 
    path: 'routeDetails', 
    loadChildren: () => import('./route-details/route-details.module').then(m => m.RouteDetailsModule),
    canLoad: [MsalGuard],
    resolve: {broker: BrokerResolver},
    data: {
      title: 'FTL QUOTE',
      navTitle: 'Route Details',
      navOrder: 2,

    } 
  }, 
  { 
    path: 'routeDetailsTender', 
    loadChildren: () => import('./route-details/route-details.module').then(m => m.RouteDetailsModule),
    canLoad: [MsalGuard],
    resolve: {broker: BrokerResolver},
    data: {
      title: 'TENDER FTL',
      navTitle: 'Route Details',
      navOrder: 2
    } 
  }, 
  { 
    path: 'review', 
    loadChildren: () => import('./review/review.module').then(m => m.ReviewModule),
    canLoad: [MsalGuard],
    resolve: {broker: BrokerResolver},
    data: {
      title: 'FTL QUOTE',
      navTitle: 'Review',
      navOrder: 3
    }
  },
  { 
    path: 'reviewTender', 
    loadChildren: () => import('./review/review.module').then(m => m.ReviewModule),
    canLoad: [MsalGuard],
    resolve: {broker: BrokerResolver},
    data: {
      title: 'TENDER FTL',
      navTitle: 'Review',
      navOrder: 3
    }
  },
  { 
    path: '**', 
    redirectTo: 'loadDetails', 
    pathMatch: 'full' 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
